import React from 'react';
import styles from '../../styles/ManageAgency.module.css';

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.inviteForm} style={{ padding: 20 }}>
    <div>{children}</div>
  </div>
);

export default AdminLayout;
